import classnames from "classnames";

import { createHigherOrderComponent } from "@wordpress/compose";
import { Component } from "@wordpress/element";
import {getHslFromHex} from "~buildable/utils/helpers";
import {THEME_VARIABLES_MAP} from "~buildable/utils/constants";

const withStylesPreview = () => createHigherOrderComponent(
  WrappedComponent => class extends Component {
    render() {
      const {
        bgMedia,
        bgMediaArray
      } = this.props.attributes;

      const classes = classnames([
        this.props.className,
        "buildable-block"
      ], {
        [`bg-${this.props.attributes.bgColor}`]: this.props.attributes.bgColor,
        [`accent-${this.props.attributes.accentColor}`]: this.props.attributes.accentColor,
        "bg-fixed": this.props.attributes.bgMediaFixed,
        [`size-${this.props.attributes.size}`]: this.props.attributes.size,
        "negative-margin-top": this.props.attributes.negativeTopMargin,
        "negative-margin-bottom": this.props.attributes.negativeBottomMargin,
        "remove-padding-top": this.props.attributes.removeTopPadding,
        "remove-padding-bottom": this.props.attributes.removeBottomPadding
      });

      const styles = {};
      if (this.props.attributes.bgColor) {
        const bgColorHex = THEME_VARIABLES_MAP[this.props.attributes.bgColor];
        if (! this.props.attributes.enableTransparentBg)  {
          styles.backgroundColor = bgColorHex;
        }

        const bgColorHsl = getHslFromHex(bgColorHex);
        styles.color = bgColorHsl.l < 50 ? "white" : "black";
      }

      if (bgMedia && bgMedia.id && bgMedia.type === "image") {
        styles.backgroundImage = `url(${bgMedia.url})`;
      } else if (bgMediaArray && bgMediaArray.length > 0 && bgMediaArray[0].type === "image") {
        styles.backgroundImage = `url('${bgMediaArray[0].url}')`;
      }

      return (
        <div className={ classes } style={ styles }>
          <WrappedComponent { ...this.props } />
        </div>
      )
    }
  },
  'withStylesPreview'
)

export default withStylesPreview;
